export default "__VITE_ASSET__DCg7tRxI__"